// Import React and Hooks
import React, { useRef } from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch } from './../../hooks/useRedux'
// Import Actions
import { showLoaderAction } from '../../actions/generalAction'
// Import Components
import OfferingImage from './OfferingImage'
// Import Html to Image
import { toJpeg } from 'html-to-image'
// Import Services
import { post } from './../../services/api'
// Import React Share
import {
	FacebookShareButton
} from 'react-share'



// Share Button Props
interface shareButtonProp {
  additionalClass?:string,
  text:string,
  id?:number,
  functionClick?: (e:React.MouseEvent) => void
}


// Variables
const apiUrl = window.location.origin === 'http://localhost:3000' ?
	'https://mxvictoriaddm.dp150.xyz/' :
	`${window.location.origin}/`


const ShareButton = ( { additionalClass, text, id, functionClick }:shareButtonProp ) => {



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use Ref
  const ref = useRef<HTMLDivElement>(null)
  const facebookBtn = useRef<any>(null)



  // Use callback
  const onButtonClick = () => {
    if (ref.current === null) return
    dispatch( showLoaderAction( true ) )

    toJpeg(ref.current, {
      quality: 0.75,
      cacheBust: true,
      width: ref.current.offsetWidth,
      height: ref.current.offsetHeight,
      style: {
        minWidth: `${ref.current.offsetWidth}px`,
        width: `${ref.current.offsetWidth}px`,
        maxWidth: `${ref.current.offsetWidth}px`,
        minHeight: `${ref.current.offsetHeight}px`,
        height: `${ref.current.offsetHeight}px`,
        maxHeight: `${ref.current.offsetHeight}px`,
        margin: 'unset',
        position: 'relative',
        right: 'initial',
        bottom: 'initial',
        opacity: '1'
      } })
    .then( dataUrl => {
      shareImg( dataUrl )
    })
    .catch( err => console.log(err) )
  }



  // Functions
  async function shareImg( image64:string ) {
    const dataEnd = {
      image: image64,
      id
    }
    try {
      const response:any = await post('sh4r31mg', dataEnd)
      if( response.status === 'ok' ) {
        dispatch( showLoaderAction( false ) )
        setTimeout( () => {
          facebookBtn.current.click()
        }, 500 )
      }
    } catch( error ) {
      console.log( error )
    }
  }



  return (
    <>
      <div className="offeringWrapper" ref={ ref } >
        <OfferingImage />
      </div>
      <button
        className={`btn btn--share ${ additionalClass ? additionalClass : ''}`}
        onClick={ onButtonClick } >
          <img
            src={`${window.assetsURl}/imgs/icons/share.svg`}
            alt="Icono de compartir"
            title="Icono de compartir"
            className="btn__icon" />
          { text }
      </button>
      <FacebookShareButton
        ref={ facebookBtn }
        url={`${apiUrl}elsabordelreencuentro?id=${id}`}
        className='facebookShare' >
      </FacebookShareButton>
    </>
  )
}



export default ShareButton
